
import React from 'react'
import AIheader from '../RentAI/AIheader';
import Footer from '../../Component/Footer/Footer';
import './CancelRefundstyle.css';
import ScrollingAnounce from '../../Component/GetAroundpage/ScrollingAnounce/ScrollingAnounce';
const CancellationRefund = () => {
  return (
    <div>
      <AIheader/>
         <main className="mainNew">
            <section className='termsBanner'>
                <h1>Cancellation & Refund Policy</h1>
            </section>
            
              <section id="terms1" className="termsMain">
                  <div className="container">
                      <div className="row align-items-center">
                          <div className="col-xl-12 col-lg-12 col-md-12">
                            <h2>Platform Protection</h2>
                            <p>All bookings on the platform include these basic protections:</p>
                            <ul>
                              <li>Bookings made 3 or more days in advance: Eligible for a full refund if cancelled within 24 
                                hours of placing the booking request.</li>
                              <li>Bookings made less than 3 days in advance: Eligible for a full refund if cancelled within 
                                1 hour of placing the booking request.</li>
                            </ul>

                            <h3>Early Returns:</h3>
                            <p>No refunds or credits will be issued for unused rental days unless a trip modification request is 
                              submitted and approved before returning the vehicle early.</p>
                        
                            <h3>No-Show Policy:</h3>
                            <p>Guests who fail to pick up the vehicle within the scheduled pickup window are subject to the same terms 
                              as cancellations made less than 24 hours before the scheduled pickup time.</p>
                          
                            <h3>Security Fees </h3> 
                            <p>Security Fees cover identity verification and personal auto insurance policy validation services. 
                              These services are non-refundable once rendered.</p>

                            <div className="termsInner">
                              <h2>Available Policy Options</h2>
                              <h3><strong>Relaxed -</strong> Provide the ultimate guest experience</h3>
                              <p>Full refund for cancellations at any time up to the pickup time.</p>
                              <h3><strong>Flexible -</strong> Cover your expenses and remain flexible</h3>
                              <p>75% refund for cancellations at any time up to the pickup time.</p>
                              <h3><strong>Moderate -</strong> Balance cost coverage and relisting opportunities</h3>
                              <p>75% refund for cancellations made more than 24 hours before the pickup time. 
                                  No refund for cancellations within 24 hours of the pickup time.</p>
                              <h3><strong>Firm -</strong> Cover majority of booking and relist with time to spare</h3>
                                <p>50% refund for cancellations made more than 24 hours before the pickup time. 
                                  No refund for cancellations within 24 hours of the pickup time.</p>
                            </div>
                          </div>
                      </div>
                  </div>
              </section> 
              <ScrollingAnounce />
        </main>
      <Footer/>
          
      
    </div>
  )
}

export default CancellationRefund